import React from "react";
import Card from "shared/Card";
import Router from "./Router";

import { useLocation } from "react-router-dom";

const PageContent = () => {
  const location = useLocation()

  const classes = location.pathname === "/referrals" ? "py-0 px-0" : "pb-0 pb-md-4"

  return (
    <Card className={classes}>
      <Router />
    </Card>
  );
};

export default PageContent;
